import { Debug as s } from "./debug-logger.es.js";
const a = 'a[href]:not([href=""])', c = (e) => {
  var n, r, o;
  if (e.parentNode === null)
    return null;
  const t = e.parentNode, i = t.closest("[data-tracking-parent-id]");
  return i !== null ? (n = i.dataset.trackingParentId) != null ? n : null : (o = (r = t.closest("[id]")) == null ? void 0 : r.getAttribute("id")) != null ? o : null;
}, d = (e) => (
  // the previous implementation used textContent over innerText. Since this is only used for links,
  // the issue in which doesn't filter out <script>,<style> elements makes no difference.
  // https://developer.mozilla.org/en-US/docs/Web/API/Node/textContent#differences_from_innertext
  (e.textContent || "").trim().replaceAll(/\s\s+/g, " ")
), f = (e) => {
  const t = {};
  for (const i in e) {
    const n = e[i];
    n != null && (typeof n == "string" && n.length === 0 || (t[i] = n));
  }
  return t;
}, k = (e, t) => {
  const i = {
    link_id: "linkId",
    link_parent_id: "linkParentId",
    link_title: "linkTitle",
    link_text: "linkText"
  }, n = {};
  for (const r of Object.keys(e)) {
    const o = e[r], l = i[r];
    o && o.length > 0 && (n[l] = o);
  }
  return n.linkUrl = t.includes("http") ? t : `${window.location.origin}${t}`, n;
}, p = (e) => {
  let t;
  if (!e.target || !(e.target instanceof Element) || e.target.closest(a) === null)
    return;
  t = e.target, t.hasAttribute("href") || (t = t.closest("[href]"));
  const i = t.getAttribute("href") || "", n = {
    link_id: t.getAttribute("id"),
    link_parent_id: c(t),
    link_title: t.getAttribute("title"),
    link_text: d(t)
  };
  if (!n.link_id && !n.link_parent_id) {
    const r = Array.isArray(t) ? t[0] : t;
    s.log("Sq.Tracking.trackLink(): No ID or parent ID associated with link:", r);
  }
  return { data: n, cdpProperties: k(n, i), href: i };
};
export {
  f as filterCDPProperties,
  p as getLinkClickEventProperties,
  c as getLinkParentId
};
